// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Wf-W","inner":"Footer_inner__129Tv","nextIcon":"Footer_nextIcon__3gIwP","innerLeft":"Footer_innerLeft__1GeWW"};